<template>
  <el-container>
    <el-aside width="201px" :span="3">
      <Sidebar /><!-- 侧栏导航 -->
    </el-aside>
    <el-container>
      <el-header>
        <el-dropdown>
          <div class="avatar-wrapper">
            <span class="nick-name">{{nickname}}</span>
            <el-icon><ArrowDown></ArrowDown></el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>设置</el-dropdown-item>
<!--              <el-dropdown-item disabled>Action 4</el-dropdown-item>-->
              <el-dropdown-item divided @click="logOut">登出</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-header>
      <el-main><router-view/></el-main>
    </el-container>
  </el-container>
</template>
<script lang="ts" setup>
import store from "../store";
const nickname = store.getters.name;
</script>

<script lang="ts">
import {defineComponent} from "vue";
import Sidebar from "@/components/sidebar/Sidebar.vue";
import { ArrowDown } from "@element-plus/icons-vue";

export default defineComponent({
  name: "AppLayout",
  components: {
    Sidebar, ArrowDown
  },
  data() {
    return {}
  },
  methods: {
    async logOut() {
      await this.$store.dispatch('user/LogOut');
      await this.$router.push('/auth/login');
      await this.logoutAction();
    },
    /*showDropdown() {
      console.log('show_dropdown');
    },*/
  },
});
</script>

<style scoped>
#app .el-header {
  position: absolute;
  height: 60px;
  width: 200px;
  right: 0;
  margin: 0;
  line-height: 60px;
  padding: 30px 30px 0 0;
  z-index: 2;
}
#app .nick-name {
  padding: 0 15px 0 0;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  color: #130f26;
}
#app .avatar-wrapper {
  padding: 0;
  float: right;
  height: 40px;
}
#app div:hover.avatar-wrapper {
  cursor: pointer;
}
</style>
<style>
#app .el-dropdown {
  float: right;
}
#app .content-header {
  height: 80px;
  z-index: 1;
}
#app .content-title {
  padding-top: 0;
  margin-top: 0;
  display: inline-block;
}
#app .but-txt {
  vertical-align: text-top;
  padding-left: 5px;
}
#app .status-tx {
  padding: 2px 15px;
  border-radius: 7px;
  display: inline-block;
}
#app .el-container, #app .el-aside {
  height: 100%;
}
#app .el-aside, #app .el-menu {
   background-color: #fafafa;
 }
</style>
<style lang="scss">
#app .el-button--primary {
  background-color: $brandColors;
  border: none;
}
#app .el-menu-item.is-active,
#app .el-pager li.active,
#app .el-pager li:hover,
.el-select-dropdown .el-scrollbar .selected,
.el-scrollbar .el-dropdown-menu li:hover {
  color: $brandColors;
}
#app .el-main {
  padding: 30px 50px;
  min-width: 1100px;
}
#app .el-main .content-header h1 {
  margin: 0;
}
</style>
